import React from "react";
import { Row, Col, Card } from "react-bootstrap";
import ReactApexChart from "react-apexcharts";
import { FiClock, FiActivity, FiAlertCircle, FiBriefcase } from "react-icons/fi";

const ITSystemCards = () => {

  /* HRMS uptime line graph */

  const uptimeChart = {
    series: [{ data: [5,8,6,12,10,14,13,9,11,6] }],
    options: {
      chart: {
        type: "line",
        sparkline: { enabled: true }
      },
      stroke: {
        curve: "smooth",
        width: 2
      },
      colors: ["#f97316"],
      tooltip: {
        enabled: true
      }
    }
  };

  /* API status bars */

  const apiChart = {
    series: [{ data: [4,6,3,7,5,8,6] }],
    options: {
      chart: {
        type: "bar",
        sparkline: { enabled: true }
      },
      colors: ["#f97316"],
      plotOptions: {
        bar: {
          columnWidth: "40%",
          borderRadius: 3
        }
      },
      tooltip: {
        enabled: true
      }
    }
  };

  /* Tickets chart */

  const ticketsChart = {
    series: [{ data: [10,20,15,25,18] }],
    options: {
      chart: {
        type: "bar",
        sparkline: { enabled: true }
      },
      colors: ["#f97316"],
      plotOptions: {
        bar: {
          columnWidth: "40%",
          borderRadius: 3
        }
      }
    }
  };

  /* Jobs chart */

  const jobsChart = {
    series: [{ data: [2,3,4,5,3,4,6,3,2,3] }],
    options: {
      chart: {
        type: "bar",
        sparkline: { enabled: true }
      },
      colors: ["#d1d5db","#f97316"],
      plotOptions: {
        bar: {
          columnWidth: "35%"
        }
      }
    }
  };

  return (
    <>


      <Row className="g-2">

        {/* CARD 1 */}

        <Col xxl={3} xl={6} md={6}>
          <Card className="dashboard-card">
            <Card.Body>

              <div className="d-flex justify-content-between mb-3">
                <span className="title">HRMS System Uptime</span>
    <div className="icon-circle">
      <FiClock className="icon" />
    </div>
              </div>

              <div className="d-flex justify-content-between align-items-center">

                <div>
                  <div className="main-value">99.9%</div>
                  <div className="sub-text">Last 30 days</div>
                </div>

                <div className="chart-area">
                  <ReactApexChart
                    options={uptimeChart.options}
                    series={uptimeChart.series}
                    type="line"
                    height={50}
                  />
                </div>

              </div>

            </Card.Body>
          </Card>
        </Col>


        {/* CARD 2 */}

        <Col xxl={3} xl={6} md={6}>
          <Card className="dashboard-card">
            <Card.Body>

              <div className="d-flex justify-content-between mb-3">
                <span className="title">API Status</span>

                <div className="icon-circle">
                  <FiActivity className="icon" />
                </div>
              </div>

              <div className="d-flex justify-content-between align-items-center">

                <div>
                  <div className="main-value">Healthy</div>
                  <div className="sub-text">All operational</div>
                </div>

                <div className="chart-area">
                  <ReactApexChart
                    options={apiChart.options}
                    series={apiChart.series}
                    type="bar"
                    height={50}
                  />
                </div>

              </div>

            </Card.Body>
          </Card>
        </Col>


        {/* CARD 3 */}

        <Col xxl={3} xl={6} md={6}>
          <Card className="dashboard-card">
            <Card.Body>

              <div className="d-flex justify-content-between mb-3">
                <span className="title">Open IT Tickets</span>

                <div className="icon-circle">
                  <FiAlertCircle className="icon" />
                </div>
              </div>

              <div className="d-flex justify-content-between align-items-center">

                <div>
                  <div className="main-value">18</div>
                  <div className="sub-text">5 high priority</div>
                </div>

                <div className="chart-area">
                  <ReactApexChart
                    options={ticketsChart.options}
                    series={ticketsChart.series}
                    type="bar"
                    height={50}
                  />
                </div>

              </div>

            </Card.Body>
          </Card>
        </Col>


        {/* CARD 4 */}

        <Col xxl={3} xl={6} md={6}>
          <Card className="dashboard-card">
            <Card.Body>

              <div className="d-flex justify-content-between mb-3">
                <span className="title">Background Jobs</span>

                <div className="icon-circle">
                  <FiBriefcase className="icon" />
                </div>
              </div>

              <div className="d-flex justify-content-between align-items-center">

                <div>
                  <div className="main-value">Running</div>
                  <div className="sub-text">12/12 jobs healthy</div>
                </div>

                <div className="chart-area">
                  <ReactApexChart
                    options={jobsChart.options}
                    series={jobsChart.series}
                    type="bar"
                    height={50}
                  />
                </div>

              </div>

            </Card.Body>
          </Card>
        </Col>
      <style>{`

      .dashboard-card{
        border:1px solid #e5e7eb;
        border-radius:10px;
        height:100%;
      }
.icon-circle {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background-color: #f3f4f6; /* light grey */
  border: 1px solid #d1d5db; /* subtle border */
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-circle .icon {
  font-size: 20px;
  color: #6b7280; /* grey icon */
}

      .title{
        font-size:15px;
        color:#374151;
      }

      .main-value{
        font-size:28px;
        font-weight:700;
        color:#0f172a;
      }

      .sub-text{
        font-size:13px;
        color:#6b7280;
      }

      .chart-area{
        width:80px;
      }

      @media(max-width:768px){
        .main-value{
          font-size:22px;
        }
      }

      `}</style>
      </Row>
    </>
  );
};

export default ITSystemCards;